/** Beschriftung des Kartenblatts und der gemalten Karte hinter den Menüs. */
import type { map as en } from '../en/map';
import type { Translated } from '../types';

export const map: Translated<typeof en> = {
  'map.furniture': 'GENERALSTAB  ·  LAGEKARTE  ·  GEHEIM',
  'map.sheet': 'Blatt {n}',
  'map.scale': '{km} km',
  'map.intercepted': 'ABGEFANGEN',
  'map.interceptedOp': 'ABGEFANGEN · {op}',
  'map.backdrop.regions': 'Die Varnischen Marken|Kesselberge|Ostmarker Tiefland|Brenner Hochfläche',
};
